import React, { SetStateAction, useState } from 'react'
import GifDetailAddToCollection from './gif-detail-add-to-colllection'
import { useCanAddGifToCollection, useGifDetailPermissions } from 'shared/hooks/use-permissions'
import {
    Container,
    Button,
    ButtonDiv,
    FavoriteStyled,
    ShareIcon,
    EmbedIcon,
    Icon,
    LeftIconContainer,
    LeftEmbed,
    LeftShare,
} from './sc'
import { trackEvent } from 'shared/util/gif-detail-ga-events'
import Test from 'react-test-attributes'
import { CY_GIF_DETAIL__DOWNLOAD_BUTTON } from 'shared/util/cy-test'

type Props = {
    gif: any
    setOverlayType: React.Dispatch<SetStateAction<string | null>>
}

const GifDetailButtons = ({ gif: { id, url, is_favorite: isFavorite }, gif, setOverlayType }: Props) => {
    const [embedHover, setEmbedHover] = useState<boolean>(false)
    const [shareHover, setShareHover] = useState<boolean>(false)
    const canAddToCollection = useCanAddGifToCollection(id)
    const permissions = useGifDetailPermissions(id)
    return (
        <Container>
            <ButtonDiv>
                <Button>
                    <FavoriteStyled
                        id={id}
                        isFavorite={!!isFavorite}
                        url={url}
                        showLabel={true}
                        onClick={props => {
                            if (!props.is_favorite) {
                                trackEvent('Favorite', id)
                            } else {
                                trackEvent('Unfavorite', id)
                            }
                        }}
                    />
                </Button>
                <Button
                    onClick={() => setOverlayType('share')}
                    onMouseEnter={() => {
                        setShareHover(true)
                    }}
                    onMouseLeave={() => {
                        setShareHover(false)
                    }}
                >
                    <LeftShare>
                        <ShareIcon active={shareHover} />
                    </LeftShare>
                    <span>Share</span>
                </Button>
                <Button
                    onClick={() => setOverlayType('embed')}
                    onMouseEnter={() => {
                        setEmbedHover(true)
                    }}
                    onMouseLeave={() => {
                        setEmbedHover(false)
                    }}
                >
                    <LeftEmbed>
                        <EmbedIcon style={{ marginTop: `2px` }} active={embedHover} />
                    </LeftEmbed>
                    <span>Embed</span>
                </Button>
                {permissions?.can_download && (
                    <Test id={CY_GIF_DETAIL__DOWNLOAD_BUTTON}>
                        <Button onClick={() => setOverlayType('download')}>
                            <LeftIconContainer>
                                <Icon className={'ss-download'} style={{ paddingTop: `3px`, fontSize: `23px` }} />
                            </LeftIconContainer>
                            <span>Download</span>
                        </Button>
                    </Test>
                )}
                {canAddToCollection && (
                    <Button>
                        <GifDetailAddToCollection gif={gif} />
                    </Button>
                )}
            </ButtonDiv>
        </Container>
    )
}

export default GifDetailButtons
